"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _warningWithoutStack = _interopRequireDefault(require("shared/warningWithoutStack"));

var _ReactSharedInternals = _interopRequireDefault(require("shared/ReactSharedInternals"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */
var warning = _warningWithoutStack.default;

if (false) {
  warning = function warning(condition, format) {
    if (condition) {
      return;
    }

    var ReactDebugCurrentFrame = _ReactSharedInternals.default.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum(); // eslint-disable-next-line react-internal/warning-and-invariant-args

    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    _warningWithoutStack.default.apply(void 0, [false, format + '%s'].concat(args, [stack]));
  };
}

var _default = warning;
exports.default = _default;
